import { Text } from "@mantine/core";
import React from "react";
import { getEntityLabel } from "../../../../../shared/filter/utils/entityDisplayUtils";

type Props = {
  total: number;
  entityRelation?: string;
};

const ConditionsMeet = ({
  total,
  entityRelation,
}: Props) => (
  <Text c="text.5" fw={400} size="xs" className="my-2">
    <Text span fw={700} ta="center">
      {total}
      {" "}
      {getEntityLabel(entityRelation || "accounts", undefined, "plural")}
    </Text>
    {" "}
    currently meet these conditions
  </Text>
);

export default ConditionsMeet;
